<template>
  <div>
    <PCNavbar selectIndex="4" pageType="Pioneer" :currentIndex="currentIndex" :section3ScrollTop="section3ScrollTop" />
    <!-- <MobileNavBar :currentActive="3" /> -->
     <Sustainability @current-index-change="handleCurrentIndexChange" @section-3-scroll-top-change="handleSection3ScrollTopChange" />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
// import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import Sustainability from '@/components/sustainability/index.vue'
export default {
  components: {
    PCNavbar,
    Sustainability
    // MobileNavBar
  },
  data() {
    return {
      currentIndex: 0,
      section3ScrollTop: 0
    }
  },
  methods: {
    handleCurrentIndexChange(index) {
      this.currentIndex = index;
      if (index !== 1) {
        this.section3ScrollTop = 0;
      }
    },
    handleSection3ScrollTopChange(scrollTop) {
      this.section3ScrollTop = scrollTop;
    }
  }
}
</script>

<style>
</style>